import React, { useEffect, useState } from 'react'
import Styles from "./Tiles.module.css"
import { trendingUp } from 'react-icons-kit/feather/trendingUp'
import { trendingDown } from 'react-icons-kit/feather/trendingDown'

import TopTitleBar from '../../pages/DashBoard/ExternalDash/TopTitleBar';
import Icon from 'react-icons-kit';
import { Link } from 'react-router-dom';

export default function VerifierDash({ title, value, total, color, linkto }) {
    const [loading, setLoading] = useState(false)
    // const percent = value / total * 100
    // let graphCss = {
    //     color: percent > 50 ? '#79b36e' : '#c07b7b'
    // }
    // if(percent){
    //     return (
    //         <div className={Styles.SMContainer}>
    //             <h2 className={Styles.title}>{title}</h2>
    //             <span className={Styles.number} style={{ color }}>{value}</span>/{total}
    //             <Icon icon={percent > 50 ? trendingUp : trendingDown} style={graphCss} size={20} />
    //         </div>
    //     )
    // }
    if (value || value==0)
        return (
            <Link to={linkto} className={Styles.link}>
                <div className={Styles.SMContainer} style={{ border: "1px solid #E5E7EB" }}>
                    <h2 className={Styles.title}>{title}</h2>
                    <span className={Styles.number} style={{ color }}>{value}</span>
                </div>
            </Link>
        )
    else {
        return (
            <div className={`shimmer ${Styles.SMContainer}`} style={{ width: "", height: "" }} />
        )
    }
}